import { render, staticRenderFns } from "./NewMessageForm.vue?vue&type=template&id=25f183c6&scoped=true&"
import script from "./NewMessageForm.vue?vue&type=script&lang=js&"
export * from "./NewMessageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f183c6",
  null
  
)

export default component.exports